import { get } from 'lodash';
import {
  getImageBackData,
  onClearData,
  onImageCollapseOpen,
} from 'src/constrains/ResponsiveLayerEditor/slice';
import { convertSpecificError } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { errCodesMap } from 'src/error/code';
import { dispatch } from 'src/store';
import { mediaTypeCheck } from 'src/tools/helper';
import { MediaType } from 'src/types/common/common';
import { EPreviewSize } from 'src/types/common/SalesChannel';

const handleOnGetData = (state) => {
  dispatch(onImageCollapseOpen([]));
  //const state = getState();
  const data = getImageBackData()(state);
  return data;
  //onSubmit(data, handleOnClear);
};
const handleOnClear = () => {
  dispatch(onClearData());
};

const errKey = {
  image: 'image',
  name: 'name',
  link: 'link',
};

const validateCarouselSetting = (data, otherProps?) => {
  const specificError = {
    [errKey.image]: [],
    [errKey.name]: [],
    [errKey.link]: [],
  };

  const { breakpoint } = otherProps || {};
  const isConvertible = breakpoint && breakpoint !== EPreviewSize.WIDE;
  const { imageLink, image, name } = data || {};
  const linkType = get(imageLink, 'linkType');
  const imageUuid = get(image, 'uuid');
  const type = mediaTypeCheck(image);
  if (!name && !isConvertible) {
    specificError[errKey.name].push(errCodesMap['999965']);
  }
  if (!imageUuid && !isConvertible) {
    specificError[errKey.image].push(errCodesMap['999964']);
  }
  if (type === MediaType.Image) {
    if (!linkType && !isConvertible) {
      specificError[errKey.link].push(errCodesMap['999963']);
    }
  }
  return {
    hasError: convertSpecificError(specificError).length > 0,
    specificError: specificError,
    generalError: [],
  };
};

const validatePosterCarouselSetting = (data, otherProps?) => {
  const specificError = {
    [errKey.image]: [],
    [errKey.name]: [],
    [errKey.link]: [],
  };
  const { breakpoint } = otherProps || {};
  const isConvertible = breakpoint && breakpoint !== EPreviewSize.WIDE;
  //console.log('isConvertible', isConvertible);
  //console.log('isConvertible', isConvertible);
  const { imageLink, image, name } = data || {};
  //console.log('name', name);
  const linkType = get(imageLink, 'linkType');

  //const imageUuid = get(image, 'uuid');
  const type = mediaTypeCheck(image);
  if (!name && !isConvertible) {
    specificError[errKey.name].push(errCodesMap['999965']);
  }

  // if (!imageUuid && !isPoster) {
  //   specificError[errKey.image].push(errCodesMap['104310']);
  // }
  if (type === MediaType.Image) {
    if (!linkType && !isConvertible) {
      specificError[errKey.link].push(errCodesMap['999963']);
    }
  }
  return {
    hasError: convertSpecificError(specificError).length > 0,
    specificError: specificError,
    generalError: [],
  };
};

export {
  handleOnGetData,
  handleOnClear,
  validateCarouselSetting,
  errKey,
  validatePosterCarouselSetting,
};
